import { useContext, useEffect } from "react";
import { getAuthenticationContext } from "../../auth/AuthenticationContext";
import getEnvConfig from "../../utils/config";
import { isAlpha, isAmazonian, isBeta } from "../../utils/environmentUtils";
import { isEventAuth } from "../../utils/urlUtils";

const ALPHA_OPS_PORTAL_URL = "https://alpha-ops.pu.training.aws.dev/ops/player";
const BETA_OPS_PORTAL_URL = "https://beta-ops.pu.training.aws.dev/ops/player";
const GBL_TICKET_URL =
  "https://t.corp.amazon.com/create/templates/74fe1503-8505-4784-abe6-6d99fbc8e481";

const getOpsPortalUrl = () => {
  if (isAlpha()) {
    return ALPHA_OPS_PORTAL_URL;
  }
  return BETA_OPS_PORTAL_URL;
};

const AmazonianNonProdAccessMessage = () => {
  return (
    <p>
      Need access to this environment? If you are a member of the GBL team, you
      can grant yourself access through the{" "}
      <a href={getOpsPortalUrl()} target="_blank" rel="noopener noreferrer">
        Ops Portal
      </a>
      . Otherwise,{" "}
      <a href={GBL_TICKET_URL} target="_blank" rel="noopener noreferrer">
        open a ticket
      </a>{" "}
      with the GBL team to request access.
    </p>
  );
};

export const AccessNotAuthorized = () => {
  const AuthenticationContext = useContext(getAuthenticationContext());

  const gameName = getEnvConfig().game_name;

  useEffect(() => {
    document.title = gameName;
  }, []);

  const showReturnToSBMessage = !isEventAuth();

  const showAmazonianNonProdMessage = (isAlpha() || isBeta()) && isAmazonian();

  return (
    <div>
      {showReturnToSBMessage && (
        <div className="cq-content">
          <p>
            Access is not authorized. If you recently subscribed, please wait up
            to 4 hours for access. If the issue persists, contact AWS Skill
            Builder support.
          </p>
          {showAmazonianNonProdMessage && <AmazonianNonProdAccessMessage />}
          <div style={{ marginTop: "4rem" }}>
            <button
              type="button"
              onClick={AuthenticationContext.logout}
              className="cq-button-primary"
            >
              Logout
            </button>
          </div>
        </div>
      )}
      {!showReturnToSBMessage && (
        <div className="cq-content">
          <p>Access is not authorized.</p>
          {showAmazonianNonProdMessage && <AmazonianNonProdAccessMessage />}
        </div>
      )}
    </div>
  );
};
